import { CORE_API } from "../constants";
import { clearAccessToken, getData, postData } from "./common.service";

type TRequestBatch = {
  limit: number;
  skip: number;
};

type TFilter = {
  plotIds?: Array<string>;
  searchText?: string;
}

type TFilterQuery = {
  include?: Array<string>;
  limit?: number;
  skip?: number;
  where?: { [key: string]: Array<object> },
};

type TUserRole = {
  id: string;
  name: string;
  created: string;
  modified: string;
}

export type TFarmUser = {
  farmUserId: string;
  name: string;
  email: string;
  countryCode: string;
  mobile: string;
  alternateMobile?: string;  
  orgId?: string;  
  gender: string;
  lang: string;
  receivables: number;
  newsPrefCategories: string[]; 
  username: string;
  updated_by: string;
  created_date: string;
  updated_date: string;
  edit: boolean;
  farms: object[];  
  roles: TUserRole[]; 
}


export const fetchUserPlots = async (
  filter: TFilter = { searchText: "", plotIds: [] },
  requestBatch: TRequestBatch = { limit: 20, skip: 0 }
) => {
  const { limit, skip } = requestBatch;
  const { searchText, plotIds } = filter;

  const filterQuery: TFilterQuery = {
    include: ["cropSown", "device"],
    limit,
    skip
  };

  if(searchText) {
    filterQuery.where = {};
    filterQuery.where = {
      or: [
        { plotId: { like: `.*${searchText}.*`, options: "i" } },
        { farmId: { like: `.*${searchText}.*`, options: "i" } },
        { name: { like: `.*${searchText}.*`, options: "i" } },
        { place: { like: `.*${searchText}.*`, options: "i" } },
        { taluka: { like: `.*${searchText}.*`, options: "i" } },
        { district: { like: `.*${searchText}.*`, options: "i" } },
        { farmUserId: { like: `.*${searchText}.*`, options: "i" } },
      ],
    };
  }

  if(plotIds && plotIds?.length > 0) {
    if(!filterQuery.where) filterQuery.where = {};
    filterQuery.where.and = [];
    filterQuery.where.and.push({ plotId: { inq: plotIds } });
  }
  
  const url = `/plots?filter=${JSON.stringify(filterQuery)}`;

  return getData(url, {
    method: "GET",
    basePath: CORE_API,
    sendTokenInHeader: true,
  });
};

/**
 * URL segment for users who do not belong to an organization. The org screens only use `orgId`
 * as a path segment (plots are loaded by token, never by org), so these users can share them.
 */
export const DEFAULT_ORG_ID = "default";

/** The org segment to use for a loaded user: their orgId, else DEFAULT_ORG_ID. */
export function getOrgSegment(user: Pick<TFarmUser, "orgId"> | null | undefined): string {
  return user?.orgId?.length ? user.orgId : DEFAULT_ORG_ID;
}

export function getUserInfo(url = "", options={}):Promise<TFarmUser> {
  return getData(url, options);
}

export async function logoutUser() {
  clearAccessToken();
  return postData("/farmusers/logout", {
    sendTokenInUrl: true,
  });
}